import React from 'react';

function ApproveConfirmModal({ isOpen, onClose, onConfirm, memberName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-hdlcc-bgWhite text-hdlcc-textDark p-6 rounded shadow-card border border-gray-200 max-w-md w-full">
        <h3 className="text-lg font-bold mb-4 text-hdlcc-textDark">Confirm Membership Approval</h3>
        <p className="mb-4 text-hdlcc-textMuted">
          Are you sure you want to approve the membership application for{' '}
          <strong className="text-hdlcc-textDark">{memberName}</strong>?
        </p>

        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-hdlcc-bgWhite text-hdlcc-textDark rounded hover:bg-gray-100 border border-gray-300 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-hdlcc-accentGreen text-white rounded hover:bg-green-600 transition-colors"
          >
            Approve Membership
          </button>
        </div>
      </div>
    </div>
  );
}

export default ApproveConfirmModal;
